import { Component, OnInit, ViewChild, enableProdMode } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { DxDataGridComponent, DxScrollViewComponent, DxDataGridModule, DxSelectBoxModule, DxCheckBoxModule, DxTemplateModule } from 'devextreme-angular';
import { AccionEspecificaService } from '../../../services/formulacion/accion-especifica.service';
import { IndicadorService } from '../../../services/formulacion/indicador.service';
import { RiesgoService } from '../../../services/formulacion/riesgo.service';
import { OperacionService } from '../../../services/formulacion/operacion.service';
import { PartidaPresService } from '../../../services/formulacion/partida-pres.service';
import { UnidadMedidaService } from '../../../services/formulacion/unidad-medida.service';
import { GeneralService } from '../../../services/formulacion/general.service';
import { switchMap } from 'rxjs/operators';
import { UtilHelper } from '../../../_helpers/util';
import { fail } from 'assert';
import { IndicadorProgramacionService } from '../../../services/service.index';

declare var jQuery: any;
declare var toastr;

@Component({
  selector: 'app-formulacion',
  templateUrl: './formulacion.component.html',
  styles: [],
  providers: [AccionEspecificaService, OperacionService, IndicadorService, PartidaPresService, UnidadMedidaService, RiesgoService]
})
export class FormulacionComponent implements OnInit {

  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  @ViewChild(DxScrollViewComponent) scrollView: DxScrollViewComponent;

  lsMeses: any = [];
  lsIndicadoresMes: any = [];
  insert: boolean = true;
  aux: boolean = false;
  detalle: any = {};
  editDetalle: boolean = false;
  clicked: boolean = false;
  modelProgramacion: any = {
    id: 0,
    variable1: '',
    variable2: '',
    indicador_id: 0,
    meta: '',
    meses: [],
  }

  scrollByContent = true;
  scrollByThumb = true;

  poaTecho: any;
  dataResourceAE: any[];
  popupVisibleIndicadorR: boolean = false;
  popupVisibleOP: boolean = false;
  popupVisibleAE: boolean = false;
  popupVisibleDelRAP: boolean = false;
  popupVisibleDelAE: boolean = false;
  popupVisibleEditAE: boolean = false;
  popupVisibleEditI: boolean = false;
  popupVisibleAddI: boolean = false;
  popupVisibleDelI: boolean = false;
  popupVisibleEditO: boolean = false;
  popupVisibleDelO: boolean = false;
  popupVisibleDelIO: boolean = false;
  popupVisibleAddRA: boolean = false;
  popupVisibleAddPL: boolean = false;
  popupVisibleP: boolean = false;  
  techoId: string;
  model: any = {};
  variable: any = { id: 0, indicador_id: 0, estado: '' };
  variable1 = false;
  variable2 = false;
  item: any = {};
  indicadoresId: number = 1;
  operacionesId: number = 1;
  operacion: any;
  indicadores: any = [];
  operaciones: any = [];
  accionEspecifica: any = {};
  dpartida: string = '';
  total = '0';
  riesgoAccionId: number;
  AEId: number;
  OPId: number;
  AEDescripcion: string;
  delIndicadorId: number;
  delOperacionId: number;
  delIndicadorO: number;
  idIndicador: number;
  gestionPOA: string;
  modelRA: any = { indicador_id: 0, riesgo: '', accion_preventiva: '' };
  modelPL: any = { operacion_id: 0, ponderacion: 0, descripcion: '', meta: 0, linea_base: 0 };
  tipo_indicador_id = [{ text: 'Frecuencia', value: 1 }, { text: 'Avance', value: 2 }];
  hasError: any;

  constructor(private route: ActivatedRoute, private router: Router, private _ae: AccionEspecificaService, private _os: OperacionService, private _is: IndicadorService, private _ps: PartidaPresService, private _us: UnidadMedidaService, private _gs: GeneralService, private _rs: RiesgoService, private _iop: IndicadorProgramacionService) {
    this.route.paramMap.pipe(switchMap((params: ParamMap) => this.techoId = params.get('id'))).subscribe();
    this.poaTecho = {
      'descripcion_techo': '',
      'techo_unidad_organizacional': '',
      'techo_categoria_programatica': '',
      'techo_tipo_gasto': '',
      'techo_tipo_intervencion': '',
      'techo_gestion': ''
    };
    this.getPoaTecho();
    this.resetErrors();
    this.gestionPOA = JSON.parse(localStorage.getItem('g'));
  }

  ngOnInit() {
    this.getAccionEspecifica();
  }

  ngAfterViewInit() {
    jQuery('.sel2').select2();
  }

  getAccionEspecifica() {
    this._ae.getListAccionEspecifica(this.techoId).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataResourceAE = result.data;
        } else {
          this.dataResourceAE = [];
        }
      },
      (error) => {
        console.log('Error', error);
      });
  }

  getPoaTecho() {
    this._gs.getPoaTechoById(this.techoId).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.poaTecho = result.data;
        } else {
          this.poaTecho = [];
        }
      },
      (error) => {
        console.log('Error', error);
      });
  }

  clearFilter() {
    this.dataGrid.instance.clearFilter();
  }

  showModalAddAE() {
    if (this.dataResourceAE == null) {
      this.clearAccionEspecifica();
      this.resetErrors();
      this.popupVisibleAE = true;
    } else {
      toastr.info('No se puede registrar más de una accción específica...');
    }
  }

  showModalEditAE(accion_esp_id: number) {
    this.getAccionEspecificaById(accion_esp_id);
    this.popupVisibleEditAE = true;
    this.resetErrors();
  }

  showModalIndicadoresR(accion_esp_id: number) {    
    this.popupVisibleIndicadorR = true;
    
  }

  onToolbarPreparingIR(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'acciones'
    });
  }


  showModalEditI(accion_esp_id: number) {
    this.getAccionEspecificaById(accion_esp_id);
    this.popupVisibleEditI = true;
  }

  showModalAddIndicador(id: number, ae: string) {
    this.AEId = id;
    this.AEDescripcion = ae;
    this.indicadores = [{ id: 1, descripcion: '', meta: '', linea_base: '', riesgo_accion: [{ id: 1, riesgo: '', accion_preventiva: '' }] }];
    this.popupVisibleAddI = true;
  }

  showModalAddOP(accion_esp_id: number) {
    this.AEId = accion_esp_id;
    this.getAccionEspecificaById(accion_esp_id);
    this.popupVisibleOP = true;
  }

  showModalEditOP(operacion_id: number) {
    this.OPId = operacion_id;
    this.getIndicadoresByIdOperacion(operacion_id);
    this.popupVisibleEditO = true;
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'acciones'
    });
  }

  
  addIndicador() {
    this.indicadoresId++;
    this.indicadores.push({
      id: this.indicadoresId,
      descripcion: '',
      meta: '',
      linea_base: '',
      riesgo_accion: [
        { id: 1, riesgo: '', accion_preventiva: '' }
      ]
    });
  }

  addRiesgoAccion(id: number) {
    for (var i = 0; i < this.indicadores.length; i++) {
      if (this.indicadores[i].id == id) {
        let id = this.indicadores[i].riesgo_accion.length + 1;
        this.indicadores[i].riesgo_accion.push({ id: id, riesgo: '', accion_preventiva: '' });
        break;
      }
    }
  }

  removeIndicador(id: number) {
    for (var i = 0; i < this.indicadores.length; i++) {
      if (this.indicadores[i].id == id) {
        this.indicadores.splice(i, 1);
        break;
      }
    }
  }

  removeRiesgoAccion(id: number, idIndicador: number) {
    for (var i = 0; i < this.indicadores.length; i++) {
      if (this.indicadores[i].id == idIndicador) {
        for (var j = 0; j < this.indicadores[i].riesgo_accion.length; j++) {
          if (this.indicadores[i].riesgo_accion[j].id == id) {
            this.indicadores[i].riesgo_accion.splice(j, 1);
            break;
          }
        }
        break;
      }
    }
  }

  addOperacion() {
    this.operacionesId++;
    this.operaciones.push({
      id: this.operacionesId,
      descripcion: '',
      ponderacion: '',
      indicador_meta: [
        { id: 1, ponderacion: '', descripcion: '', meta: '', linea_base: '' }
      ]
    });
  }

  addOperacionIndicador() {
    this.indicadoresId = 1;
    this.indicadoresId++;
    this.indicadores.push({
      id: this.indicadoresId, ponderacion: '', descripcion: '', meta: '', linea_base: '', medio_verificacion: '', tipo_indicador_id: '', unidad_medida: ''
    });
  }

  removeOperacion(id: number) {
    for (var i = 0; i < this.operaciones.length; i++) {
      if (this.operaciones[i].id == id) {
        this.operaciones.splice(i, 1);
        break;
      }
    }
  }

  removeOperacionIndicador(id: number, idOperacion: number) {
    for (var i = 0; i < this.indicadores.length; i++) {
      if (this.indicadores[i].id == id) {
        this.indicadores.splice(i, 1);
        break;
      }
    }
  }

  saveAccionEspecificaIndicadores() {
    if (this.validSaveAE()) {
      let data = { techo_id: this.techoId, id: this.model.id, descripcion: this.model.accionEspecifica, indicadores: this.indicadores };
      if (this.model.id == 0) {
        this._ae.postAccionEspecifica(data).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.popupVisibleAE = false; this.refreshDataGrid();
              toastr.success('Datos guardados exitosamente.');
            }
          },
          (error) => { console.log('Error', error); });
      }
    }
  }

  updateAccionEspecifica() {
    if (this.validSaveAE()) {
      this._ae.putAccionEspecifica({ id: this.model.id, descripcion: this.model.accionEspecifica }).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.popupVisibleEditAE = false; this.refreshDataGrid();
            toastr.success('Datos actualizados exitosamente.');
          }
        },
        (error) => { console.log('Error', error); });
    }
  }

  saveAccionEspecificaOperacion() {
    let data = { accion_especifica_id: this.AEId, operaciones: this.operaciones };
    if (this.validPonderacionPonderacion()) {
      this._ae.postAccionEspecificaOperaciones(data).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.popupVisibleOP = false;
            this.getAccionEspecifica();
            toastr.success('Operaciones creadas exitosamente.');
          }
        },
        (error) => { console.log('Error', error); });
    }
  }

  saveIndicadores() {
    let data = { operacion_id: this.OPId, indicadores: this.indicadores };    
    if (this.validIndicadores()) {
      this._ae.postOperacionIndicadores(data).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.getIndicadoresByIdOperacion(this.OPId);
            this.popupVisibleEditO = false;
            this.refreshDataGrid();
            toastr.success('Indicadores registrados exitosamente.');
          }
        },
        (error) => { console.log('Error', error); });
    }
  }

  getIndicadoresByIdOperacion(id: number) {
    this._ae.getListIndicadoresByOperacionId(id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {          
          this.operacion = result.data.descripcion;
          this.indicadores = result.data.indicadores;
        }
        if (result.data.indicadores.length == 0) {
          this.addOperacionIndicador();
        }
      },
      (error) => { console.log('Error', error); });
  }

  getAccionEspecificaById(id: number) {
    this._ae.getAccionEspecificaById(id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.model = {};
          this.model.id = result.data.id;
          this.model.accionEspecifica = result.data.descripcion;
          this.indicadores = result.data.indicadores;
          this.operaciones = result.data.operaciones;
        }
        if (result.data.operaciones.length == 0) {
          this.addOperacion();
        }
      },
      (error) => { console.log('Error', error); });
  }

  validPonderacion() {
    let t = 0, ti = 0, f = false, r = true, f2 = false;
    this.operaciones.forEach(item => {
      t += item.ponderacion != '' ? parseInt(item.ponderacion) : 0;
      ti = 0;
      item.indicador_meta.forEach(item1 => {
        ti += item1.ponderacion != '' ? parseInt(item1.ponderacion) : 0;
        if (ti > 100) f = true;
      });
      if (ti != 100) f2 = true;
    });
    if (t > 100) {
      toastr.warning('Sobrepasó el 100% de la ponderación de las Operaciones');
      r = false;
    }
    else {
      if (t != 100) {
        toastr.warning('La suma de las ponderaciones de las Operaciones debe ser igual a 100%');
        r = false;
      }
    }
    if (f) {
      toastr.warning('Sobrepasó el 100% en la ponderación de algún Indicador Meta');
      r = false;
    }
    else {
      if (f2) {
        toastr.warning('La suma de las ponderaciones en los Indicadores Meta debe ser igual a 100%');
        r = false;
      }
    }
    return r;
  }

  validPonderacionPonderacion() {
    let t = 0, ti = 0, f = false, r = true, f2 = false, f3 = false;
    this.operaciones.forEach(item => {
      if ((item.ponderacion == '') || (item.descripcion == ''))
        f3 = true;
      t += item.ponderacion != '' ? parseInt(item.ponderacion) : 0;
    });
    if (f3) {
      r = false;
      toastr.warning('Complete los datos...');
    }
    if (t > 100) {
      toastr.warning('Sobrepasó el 100% de la ponderación de las Operaciones');
      r = false;
    }
    else {
      if (t != 100) {
        toastr.warning('La suma de las ponderaciones de las Operaciones debe ser igual a 100%');
        r = false;
      }
    }
    return r;
  }

  validIndicadores() {
    let t = 0, ti = 0, f = false, r = true, f2 = false, f3 = false;
    this.indicadores.forEach(item1 => {
      if ((item1.ponderacion == '') || (item1.ponderacion == null) || (item1.descripcion == '') || (item1.descripcion == null) || (item1.meta == '') || (item1.meta == null) || (item1.medio_verificacion == '') || (item1.medio_verificacion == null))
        f3 = true;
      ti += item1.ponderacion != '' ? parseInt(item1.ponderacion) : 0;
      if (ti > 100) f = true;
    });
    if (f3) {
      r = false;
      toastr.warning('Complete los datos...');
    }
    if (ti != 100) f2 = true;
    if (f) {
      toastr.warning('Sobrepasó el 100% en la ponderación de algún Indicador Meta');
      r = false;
    }
    else {
      if (f2) {
        toastr.warning('La suma de las ponderaciones en los Indicadores Meta debe ser igual a 100%');
        r = false;
      }
    }
    return r;
  }

  clearAccionEspecifica() {
    this.model = { id: 0, accionEspecifica: '' };
    this.indicadoresId = 1;
    this.operacionesId = 1;
    this.indicadores = [{
      id: 1,
      descripcion: '',
      meta: '',
      linea_base: '',
      riesgo_accion: [
        { id: 1, riesgo: '', accion_preventiva: '' }
      ]
    }];
    this.operaciones = [{
      id: 1,
      descripcion: '',
      ponderacion: '',
      indicador_meta: [
        { id: 1, ponderacion: '', descripcion: '', meta: '', linea_base: '' }
      ]
    }];
  }

  refreshDataGrid() {
    this.getAccionEspecifica();
    this.dataGrid.instance.refresh();
  }

  onlyNumbersInt(e: any) {
    UtilHelper.onlyNumbersInt(e);
  }

  linkTareas(aid: number) {
    this.router.navigate(['/formulario/tarea/', this.techoId, aid]);    
  }

  deleteRiesgoAccion(id: number) {
    this.popupVisibleDelRAP = true;
    this.riesgoAccionId = id;
  }

  deleteRiesgoAP() {
    this.popupVisibleDelRAP = false;
    this._rs.deleteRiego(this.riesgoAccionId).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.refreshDataGrid();
          this.popupVisibleDelRAP = false;
          this.popupVisibleEditI = false;
          toastr.success('Operación realizada exitosamente.');
        }
        else {
          toastr.warning('Ocurrió un inconveniente al realizar la operación.');
        }
      },
      error => { console.log('Error', error); });
  }

  resetErrors() {
    this.hasError = { ae: false, variable1: false, variable2: false };
  }

  validSaveAE() {
    let res = true;
    if (!UtilHelper.validator(this.model.accionEspecifica, 'text')) {
      this.hasError.ae = true; res = false;
    }
    return res;
  }

  showModalDeleteAE(id: number) {
    this.popupVisibleDelAE = true;
    this.AEId = id;
  }

  deleteAE() {
    this._ae.deleteAccionEspecifica(this.AEId).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.refreshDataGrid();
          this.popupVisibleDelAE = false;
          toastr.success('Acción Específica eliminada exitosamente.');
        }
        else if (result.status == 201) {
          toastr.warning('No es posible eliminar la Acción Específica, debido a que tiene indicadores u operaciones asociadas.');
        }
        else {
          toastr.warning('Ocurrió un inconveniente al borrar la Acción Específica.');
        }
      },
      error => { console.log('Error', error); });
  }

  updateIndicador(id: number) {
    let i = this.indicadores.filter(o => o.id == id).map(o => o)[0];
    this._is.putIndicador(i).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.popupVisibleEditI = false; this.refreshDataGrid();
          toastr.success('Datos actualizados exitosamente.');
        }
      },
      (error) => { console.log('Error', error); });
  }

  updateRiesgoAccion(idi: number, id: number) {
    let i = this.indicadores.filter(o => o.id == idi).map(o => o)[0];
    let ra = i.riesgo_accion.filter(o => o.id == id).map(o => o)[0];
    this._rs.putRiesgo(ra).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.popupVisibleEditI = false; this.refreshDataGrid();
          toastr.success('Datos actualizados exitosamente.');
        }
      },
      (error) => { console.log('Error', error); });
  }

  saveIndicador() {
    let i = this.indicadores[0];
    this._is.postIndicadorRiesgos({ accion_especifica_id: this.AEId, descripcion: i.descripcion, meta: i.meta, linea_base: i.linea_base, riesgos: i.riesgo_accion }).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.popupVisibleAddI = false; this.refreshDataGrid();
          toastr.success('Datos guardados exitosamente.');
        }
      },
      (error) => { console.log('Error', error); });
  }

  showModalDeleteInd(id: number) {
    this.popupVisibleDelI = true;
    this.delIndicadorId = id;
  }

  deleteIndicador() {
    this._is.deleteIndicador(this.delIndicadorId).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.refreshDataGrid();
          this.popupVisibleDelI = false;
          this.popupVisibleEditI = false;
          toastr.success('Indicador eliminado exitosamente.');
        }
        else if (result.status == 201) {
          toastr.warning('No es posible eliminar el Indicador, debido a que tiene elementos asociados.');
        }
        else {
          toastr.warning('Ocurrió un inconveniente al borrar el Indicador.');
        }
      },
      error => { console.log('Error', error); });
  }

  updateOperacion(id: number) {
    if (this.validPonderacion()) {
      let o = this.operaciones.filter(o => o.id == id).map(o => o)[0];
      this._os.putOperacion(o).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            //this.popupVisibleEditO = false; 
            this.refreshDataGrid();
            toastr.success('Datos actualizados exitosamente.');
          }
          else if (result.status == 210) {
            toastr.success('No es posible modificar los datos debido a que existen registros de ejecución.');
          }
        },
        (error) => { console.log('Error', error); });
    }
  }

  showModalDeleteOperacion(id: number) {
    this.popupVisibleDelO = true;
    this.delOperacionId = id;
  }

  deleteOperacion() {
    this._os.deleteOperacion(this.delOperacionId).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.getAccionEspecificaById(this.AEId);
          this.refreshDataGrid();
          this.popupVisibleDelO = false;
          toastr.success('Operación eliminada exitosamente.');
        }
        else if (result.status == 201) {
          toastr.warning('No es posible eliminar la Operación, debido a que tiene Indicadores y/o Tareas asociadas.');
        }
        else if (result.status == 210) {
          toastr.success('No es posible eliminar la Operación debido a que existen registros de ejecución.');
        }
        else {
          toastr.warning('Ocurrió un inconveniente al borrar la Operación.');
        }
      },
      error => { console.log('Error', error); });
  }

  showModalDeleteIndicadorO(id: number) {
    this.popupVisibleDelIO = true;
    this.delIndicadorO = id;
  }

  deleteIndicadorO() {
    this.popupVisibleDelIO = false;
    this._os.deleteIndicadorOperacion(this.delIndicadorO).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.getIndicadoresByIdOperacion(this.OPId);
          this.popupVisibleDelIO = false;
          toastr.success('Operación realizada exitosamente.');
        }
        else {
          toastr.warning('Ocurrió un inconveniente al realizar la operación.');
        }
      },
      error => { console.log('Error', error); });
  }

  updateIndicadorO(ido: number, id: number) {
    if (this.validPonderacion()) {
      let o = this.operaciones.filter(o => o.id == ido).map(o => o)[0];
      let im = o.indicador_meta.filter(o => o.id == id).map(o => o)[0];
      this._os.putIndicadorOperacion(im).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            //this.popupVisibleEditO = false; 
            this.refreshDataGrid();
            toastr.success('Datos actualizados exitosamente.');
          }
        },
        (error) => { console.log('Error', error); });
    }
  }

  showModalAddRA(id: number) {
    this.popupVisibleAddRA = true;
    this.modelRA = { indicador_id: id, riesgo: '', accion_preventiva: '' };
  }

  addRAIndicador() {
    this._rs.postAddRiesgo(this.modelRA).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.popupVisibleAddRA = false;
          this.popupVisibleEditI = false; this.refreshDataGrid();
          toastr.success('Datos actualizados exitosamente.');
        }
      },
      (error) => { console.log('Error', error); });
  }

  showModalAddPL(id: number) {
    this.popupVisibleAddPL = true;
    this.modelPL = { operacion_id: id, ponderacion: 0, descripcion: '', meta: 0, linea_base: 0 };
  }

  addPLOperacion() {
    this._os.postIndicadorOperacion(this.modelPL).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.popupVisibleAddPL = false;
          this.popupVisibleEditO = false; this.refreshDataGrid();
          toastr.success('Datos actualizados exitosamente.');
        }
      },
      (error) => { console.log('Error', error); });
  }


  showModalProgramacion(id: number, meta: number, ind: string) {
    this.resetErrors();
    this.variable1 = false;
    this.variable2 = false;
    this.popupVisibleP = true;
    this.idIndicador = id;
    this.modelProgramacion.meta = meta;
    this.cargarIndicadorMesPorIndicador();
    this.modelProgramacion.variable1 = ind;
  }


  saveProgramacion() {
    this.resetErrors();
    if (this.validIndicadoresMes()) {
      if (this.insert == true) {
        this.modelProgramacion.meses = this.lsIndicadoresMes;
        this.modelProgramacion.indicador_id = this.idIndicador;
        this._iop.postIndicadorMes(this.modelProgramacion).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.popupVisibleP = false;
              toastr.success('Datos guardados exitosamente.');
            }
          },
          (error) => { console.log('Error', error); });
      }
      else {
        this.modelProgramacion.meses = this.lsIndicadoresMes;
        this.modelProgramacion.indicador_id = this.idIndicador;
        this._iop.putIndicadorMes(this.modelProgramacion).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.popupVisibleP = false;
              toastr.success('Datos actualizados exitosamente.');
            }
          },
          (error) => { console.log('Error', error); });
      }
    }
  }  

  cargarIndicadorMesPorIndicador() {
    this._iop.getListIndicadoresMesPorIndicador(this.idIndicador)
      .subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.lsIndicadoresMes = result.data;
            this.insert = false;
            this.getListSoloMeses();
            this.aux = false;
          }
          if (result.status == 201) {
            this.insert = true;
            this.getListMeses();
            this.aux = true;
          }
        },
        (error) => { console.log('Error', error); });
  }

  validIndicadoresMes() {
    let r = true, f1 = false, f2 = false, f3 = false, f4 = false, total = 0;
    this.lsIndicadoresMes.forEach(item => {
      total = total + parseFloat(item.valor_indicador);
      if ((item.valor_indicador < 0) && (item.valor_indicador != 0))
        f1 = true;
    });

    if ((total.toFixed(2) != this.modelProgramacion.meta)) {
      f4 = true;
    }

    // if (!UtilHelper.validator(this.modelProgramacion.variable1, 'text')) {
    //   f2 = true;
    // }
    // if (!UtilHelper.validator(this.modelProgramacion.variable2, 'text')) {
    //   f3 = true;
    // }
    if (f1) {
      r = false;
      toastr.warning('Complete los datos...');
    }
    // if ((f2) || (f3)) {
    //   r = false;
    //   toastr.warning('Ingrese datos en las variables');
    // }
    if ((f4)) {
      r = false;
      toastr.warning('Los datos deben ser igual a la meta programada...');
    }
    return r;
  }

  getListMeses() {
    this._iop.getListMeses()
      .subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.lsMeses = result.data;
            if (this.insert == true) {
              this.lsIndicadoresMes = [];
              for (var _i = 0; _i < this.lsMeses.length; _i++) {
                var item = this.lsMeses[_i];
                let id = this.lsMeses.length + 1;
                this.lsIndicadoresMes.push({ id: _i, valor_indicador: '', mes_id: this.lsMeses[_i].id, mes: this.lsMeses[_i].mes });
              }
            }
          }
        },
        (error) => { console.log('Error', error); });
  }
  getListSoloMeses() {
    this._iop.getListMeses()
      .subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.lsMeses = result.data;
          }
        },
        (error) => { console.log('Error', error); });
  }

  sugerirProgramacion() {
    for (var _i = 0; _i < this.lsIndicadoresMes.length; _i++) {
      var itemIndicadorMes = this.lsIndicadoresMes[_i];
      var valorInicial = this.modelProgramacion.meta / 12;
      itemIndicadorMes.valor_indicador = + valorInicial.toFixed(2);
    }
  }

}
